/* ----------------- React --------------- */
import type React from "react";
import { forwardRef } from "react";

/* ----------------- React Native --------------- */
import { ScrollView, type ScrollViewProps } from "react-native";

/* ----------------- Components --------------- */
import Container, { type ContainerProps } from "../Container";

import { isWeb } from "@memorang/helpers/platform";
/* ----------------- Types --------------- */
import type { AlignItems } from "../Box";

type Props = {
	children: React.ReactNode;
	maxWidth?: "xxs" | "xs" | "sm" | "md" | "lg";
	alignItems?: AlignItems;
	containerProps?: Omit<ContainerProps, "children">;
} & ScrollViewProps;

const ScrollContainer = forwardRef<ScrollView, Props>(
	(
		{
			children,
			containerProps,
			maxWidth,
			alignItems,
			contentContainerStyle,
			...rest
		},
		ref,
	) => {
		return (
			<ScrollView
				ref={ref}
				showsVerticalScrollIndicator={isWeb}
				contentContainerStyle={[{ flexGrow: 1 }, contentContainerStyle]}
				{...rest}
			>
				<Container
					alignItems={alignItems}
					maxWidth={maxWidth || "md"}
					{...(containerProps || {})}
				>
					{children}
				</Container>
			</ScrollView>
		);
	},
);

export default ScrollContainer;
